import Image from 'next/image';
import {
  bhartiAxa,
  hdfcLife,
  iciciLombard,
  iffcoTokio,
  bajajAllianz,
  birlaSunlife,
  careHealth,
  chola,
  digit,
  // hdfcLifeNew,
  hdfcERGO,
  iciciPrudential,
  // iciciLombardNew,
  // iffcoTokioNew,
  kotak,
  lic,
  national,
  newIndia,
  niva,
  pnbMetlife,
  royalSundaram,
  sbiGeneral,
  starHealth,
  tataAig,
  orientalInsurance,
  unitedIndia,
} from '@prishapolicy/shared/assets';
export const BhartiAxa = () => <Image src={bhartiAxa} alt="Bharti Axa" />;
export const ICICILombard = () => (
  <Image src={iciciLombard} alt="ICICI Lombard" />
);
export const HDFCLife = () => <Image src={hdfcLife} alt="HDFC Life" />;
export const IFFCOTokio = () => <Image src={iffcoTokio} alt="IFFCO Tokio" />;
export const BajajAllianz = () => (
  <Image src={bajajAllianz} alt="Bajaj Allianz" />
);
export const BirlaSunlife = () => (
  <Image src={birlaSunlife} alt="Birla Sun Life" />
);
export const CareHealth = () => <Image src={careHealth} alt="Care Health" />;
export const Chola = () => <Image src={chola} alt="Chola" />;
export const Digit = () => <Image src={digit} alt="Digit" />;
export const HDFCERGO = () => <Image src={hdfcERGO} alt="HDFC ERGO" />;
export const ICICIPrudential = () => (
  <Image src={iciciPrudential} alt="ICICI Prudential" />
);
export const Kotak = () => <Image src={kotak} alt="Kotak" />;
export const LIC = () => <Image src={lic} alt="LIC" />;
export const National = () => <Image src={national} alt="National" />;
export const NewIndia = () => <Image src={newIndia} alt="New India" />;
export const Niva = () => <Image src={niva} alt="Niva" />;
export const PNBMetLife = () => <Image src={pnbMetlife} alt="PNB Metlife" />;
export const RoyalSundaram = () => (
  <Image src={royalSundaram} alt="Royal Sundaram" />
);
export const SBIGeneral = () => <Image src={sbiGeneral} alt="SBI General" />;
export const STARHealth = () => <Image src={starHealth} alt="STAR Health" />;
export const TATAAIG = () => <Image src={tataAig} alt="TATA AIG" />;
export const OrientalInsurance = () => (
  <Image src={orientalInsurance} alt="Oriental Insurance" />
);
export const UnitedIndia = () => <Image src={unitedIndia} alt="United India" />;
